import { isDefinedString, reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import Et3Image from "../../../../../../core/et3-Image";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../Types";

const SendMessageButton = withLiteObserverAndTheme<{
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  conversationID: string;
  peerID: number;
  peerUUID: string;
  conversationType: TalkhattabatConversationType;
  oneOTwoConversationId: string;
  oneOOneCId: string
}>((props) => {
  const {
    theme,
    conversationID,
    oneOTwoConversationId,
    alkhattabaUUID,
    userUUID,
    peerID,
    peerUUID,
    conversationType,
    userID,
    oneOOneCId
  } = props;
  const { colors, unitX } = theme;

  const alkhattabaText = reduce(
    () =>
      getKhattabatStore().conversationsProps.get(conversationID).messageField,
    ""
  );
  const shouldSend = isDefinedString(alkhattabaText);
  const isOneOneCConversation = conversationType === "101C";
  const isOneOOneMConversation = conversationType === "101M";
  const isOneOOneCComment = conversationType === "101C_COMMENTS";
  const isOneOOneMComment = conversationType === "101M_COMMENTS";
  const buttonText = isOneOOneCComment ? "ADD" : "SEND";
  const buttonColor = !shouldSend
    ? colors.all.gray
    : conversationType === "101C_COMMENTS"
      ? colors.all.red
      : colors.all.bondiBlue;
  return (
    <ET3Div
      width={108}
      height={40}
      alignItems={"center"}
      fDirection={"row"}
      justifyContent={"center"}
      style={{
        backgroundColor: buttonColor,
        borderRadius: 41 * unitX,
        cursor: "pointer"
      }}
      color={""}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {
        switch (true) {
          case isOneOneCConversation:
          case isOneOOneCComment:
            return getKhattabatStore().sendOneOMessageDatabase({
              alkhattabaUUID,
              userUUID,
              alkhattabaText,
              conversationID,
              userID,
              conversationType,
              oneOOneCId
            });
          case isOneOOneMConversation:
          case isOneOOneMComment:
            return getKhattabatStore().sendOneOMessageDatabase({
              alkhattabaUUID,
              userUUID: peerUUID,
              alkhattabaText,
              conversationID,
              userID: peerID,
              conversationType,
              oneOOneCId
            });
          default:
            return getKhattabatStore().sendOneTwoMessageDatabase({
              alkhattabaUUID,
              userUUID,
              userID,
              alkhattabaText,
              peerID,
              peerUUID,
              conversationID,
              oneOTwoConversationId,
              oneOOneCId
            });
        }
      }}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={18}
        isSpan={false}
        text={i18n.get(buttonText)}
        style={{}}
        color={colors.all.white}
      />
      <Et3Margin left={1} right={1} top={0} bottom={0} />
      <Et3Image
        type="LOCAL"
        alt={i18n.get(buttonText)}
        imageName={"send"}
        size={18}
        onClick={() => { }}
        style={{}}
      />
    </ET3Div>
  );
});

export default SendMessageButton;
